export default "__VITE_ASSET__62d424fe__"